import { useState, useEffect } from "react"
import axios from "axios"
import api from "./axiosInterceptor.js"

axios.defaults.withCredentials = true

export default function FetchWithParams(url, params, reload, updateReload) {

    const [highLevelStats, setHighLevelStates] = useState({
        data: null,
        error: null,
        load: true
    })
    useEffect(() => {
        console.log('in use effect for params ')
        async function getData() {
            setHighLevelStates((cur) => ({ ...cur, load: true }))
            try {

                const response = await api.get(`api/${url}`, {
                    params: params
                })

                if (response.status === 200) {
                    setHighLevelStates((cur) => ({ ...cur, data: response.data }))
                    // setData(response.data)
                }
                else {
                    updateReload(false)
                    throw response
                }

            } catch (err) {
                updateReload(false)
                setHighLevelStates((cur) => ({ ...cur, error: err }))
                // setError(err)
            } finally {

                updateReload(false)
                setHighLevelStates((cur) => ({ ...cur, load: false }))
                // setLoad(false)
            }
        }
        if (!params) {
            updateReload(false)
        }
        if (params && reload) {
            getData()
        }
        // getData()
    }, [url, reload])
    return { "data": highLevelStats.data, "error": highLevelStats.err, "load": highLevelStats.load }
}